import {useEffect, useState} from "react";
import { $contractorDems } from "../logics/contractorDemands";
import { ServiceListItem } from "../molecules/ServiceListItem";
import { ServicesTopBar } from "../molecules/GroupServicesTopBar";
import { ServicesBasket } from "../organoids/ServicesBasket";
import { IContractorService } from "../logics/types";
import "../styles/troubleshoot.css";
import { useStore } from "effector-react";

interface IOrderGroupServices {
  groupId: string | undefined,
  currSidebarItem: string,
  demsUpd: boolean; //при изменении этого флага обновляем заявки
  hideArchive?: boolean; //указывает на то, что нужно скрыть архивные заявки
  companyId: number; //компания по которому запрашиваются заявки
  accountId: number; //аккаунт по которому запрашиваются заявки
}

export const OrderGroupServices = ({
  groupId,
  currSidebarItem,
  demsUpd,
  companyId,
  accountId,
  hideArchive = true,
}: IOrderGroupServices) => {
  console.log("props::", groupId)
  const {failMsg, services, loading, groups} = useStore($contractorDems)
  const [groupServices, setGroupServices] = useState<IContractorService[]>([]);
  const [serviceIDsInBasket2, setServiceIDsInBasket2] = useState<object>({})
  const [serviceIDs, setServiceIDs] = useState<string[]>(Object.keys(serviceIDsInBasket2))
  const [openBasketClicked, setOpenBasketClicked] = useState(false)
  const updGroupServices = () => {
    //@ts-ignore
    setGroupServices(services.filter(s => s.demandGroupId == groupId))
  }
  useEffect(() => {
    updGroupServices()
  }, [groupId, services]);

  useEffect(() => {
    setServiceIDs(Object.keys(serviceIDsInBasket2))
  }, [serviceIDsInBasket2]);

  const getServCount = (sid: number) => {
    //@ts-ignore
    let c = serviceIDsInBasket2[sid+'']
    return c == undefined ? 0 :c
  }

  const getForAllAndGroupName = (sid: number) => {
    let group = groups.find(g => g.id == sid)
    console.log("FOL_ALL:", sid, group, groups)
    let tmp = {
      forAll: group == undefined ? true : group.forAll == 1,
      groupName: group == undefined ? "" : group.name,
    }
    return tmp
  }

  console.log("gr_s:",  serviceIDsInBasket2)
  if (groupServices.length === 0) {
    if (loading) return <div>Загрузка данных...</div>;
    if (failMsg != "") return <div>{failMsg}</div>;
    return <div>Заявки не обнаружены!</div>;
  }

  return (
    <>
      <ServicesTopBar setShowBasket={setOpenBasketClicked} serviceCount={Object.keys(serviceIDsInBasket2).length} title={currSidebarItem} />
      <div className="d-flex flex-wrap">
        {groupServices.map((s, i) => (
          <ServiceListItem forAllAndGroupName={getForAllAndGroupName(s.demandGroupId)} countInBasket={getServCount(s.id)} seviceIDsInBasket2 ={serviceIDsInBasket2} setSeviceIDsInBasket2={setServiceIDsInBasket2} service={s} key={i} inBasket={serviceIDs.indexOf(s.id+'') != -1} />
        ))}
      </div>
      {openBasketClicked ? <ServicesBasket companyId={companyId} accountId={accountId} serviceIDsInBasket2={serviceIDsInBasket2} setServiceIDsInBasket2={setServiceIDsInBasket2} setShowBasket={setOpenBasketClicked}/> : <></>}
    </>
  );
};
